/**
 * Fit text to its container
 *
 * - used as Alpine directive
 *
 * @param {Number|String} expression  will contain the value from the HTML (e.g., '24')
 *
 * @return {Void}
 */
export const fitText = (el, { expression }) => {
    const MAX_SIZE = parseInt(expression) || 16;

    const containerWidth = el.parentElement.offsetWidth;
    let currentSize = MAX_SIZE;

    el.style.display = 'inline-block';
    el.style.whiteSpace = 'nowrap';
    el.style.overflow = 'hidden';
    el.style.fontSize = MAX_SIZE + 'px';

    // Shrinking Logic
    if (el.scrollWidth > containerWidth) {
        while (el.scrollWidth > containerWidth && currentSize > 1) {
            currentSize -= 0.5;
            el.style.fontSize = currentSize + 'px';
        }
    }
}
